import * as React from 'react';
import type { SVGProps } from 'react';
const SvgTag = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <path d="M6.736 17.187a2.765 2.765 0 0 0 3.916 0l5.768-5.745c.373-.37.582-.876.58-1.403V3.791A.79.79 0 0 0 16.209 3h-6.25a1.97 1.97 0 0 0-1.404.58L2.809 9.346a2.774 2.774 0 0 0 0 3.915zm-2.822-6.726L9.676 4.7a.4.4 0 0 1 .283-.118h5.458v5.457a.42.42 0 0 1-.117.283l-5.763 5.76c-.47.448-1.21.448-1.68 0L3.913 12.14a1.19 1.19 0 0 1 0-1.68Z" />
  </svg>
);
export default SvgTag;
